import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BCBaseComponent } from './bc-base/bc-base.component';
import { BCNavbarComponent } from './bc-navbar/bc-navbar.component';
import { BCSidebarComponent } from './bc-sidebar/bc-sidebar.component';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { BCLayoutRoutingModule } from './bc-layout-routing.module';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbCollapseModule, NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FooterModule } from '../layout/footer/footer.module';
import { FeahterIconModule } from 'src/app/core/feather-icon/feather-icon.module';
import { DirectivesModule } from '../layout/directives/directives.module';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSelectFilterModule } from 'mat-select-filter';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { UserService } from 'src/app/services/user.service';
import { DashboardService } from 'src/app/services/dashboard.service';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  declarations: [BCBaseComponent, BCNavbarComponent, BCSidebarComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgbDropdownModule,
    NgbCollapseModule,
    FooterModule,
    PerfectScrollbarModule,
    FeahterIconModule,
    DirectivesModule,
    MatDialogModule,
    TranslateModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatSelectFilterModule,
    BCLayoutRoutingModule,
    CarouselModule,
    NgbModule,
  ],
  providers: [
      {
        provide: PERFECT_SCROLLBAR_CONFIG,
        useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
      },
      UserService,
      DashboardService,
  ]
})
export class BCLayoutModule {}